import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartChatStreamMutationVariables = Types.Exact<{
  message: Types.Scalars['String']['input'];
  user_id: Types.Scalars['String']['input'];
  workspace_id: Types.Scalars['String']['input'];
  organization_id: Types.Scalars['String']['input'];
  stream_id: Types.Scalars['String']['input'];
  doctrine_chat_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  selected_properties_ids?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  selected_installed_products_ids?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  selected_products_ids?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  installed_product_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  shop_product_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  guide_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  files?: Types.InputMaybe<Array<Types.FileAttachmentInput> | Types.FileAttachmentInput>;
  is_brief?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  brief_frequency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  chat_type?: Types.InputMaybe<Types.Scalars['String']['input']>;
  chat_origin?: Types.InputMaybe<Types.Scalars['String']['input']>;
  screen_description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  screen_property_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  screen_jurisdiction_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StartChatStreamMutation = { __typename?: 'mutation_root', start_chat_stream?: Array<{ __typename?: 'webAiChatMessageOutput', id: string, message: string, isSystem: boolean, createdAt: string, userId?: string | null, chatId: string, thoughts?: string | null, user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, profile_photo?: string | null } | null, multimodal_attachments?: Array<{ __typename?: 'ChatMessageAttachment', id: string, fileName: string, mimeType: string, publicUrl?: string | null, fileType: string, fileKey?: string | null, gsUri?: string | null } | null> | null, citations?: { __typename?: 'CitationMetadata', chunks: Array<{ __typename?: 'CitationChunk', uri: string, title: string }>, supports: Array<{ __typename?: 'CitationSupport', groundingChunkIndices: Array<number>, segment: { __typename?: 'CitationSegment', text: string, startIndex: number, endIndex: number } }> } | null, aiChat?: { __typename?: 'ai_chats', id: any, doctrine_chat_id: string, workspace_id?: any | null, partition_id?: string | null, partitions_ids?: Array<string> | null, organization_id?: any | null, created_at: any, doctrine_title?: string | null, is_brief: boolean, brief_frequency?: string | null, ai_chat_user_selections: Array<{ __typename?: 'ai_chat_user_selections', id: any, property_id?: any | null, product_id?: any | null, installed_product_id?: any | null, shop_product_id?: any | null, property?: { __typename?: 'properties', id: any, name: string } | null, product?: { __typename?: 'products', id: any, name: string } | null, installed_product?: { __typename?: 'installed_products', id: any, product_id: any, property_id: any, product: { __typename?: 'products', id: any, name: string }, property?: { __typename?: 'properties', id: any, name: string } | null } | null, shop_product?: { __typename?: 'shop_products', id: any, product_id: any, property_id: any, product?: { __typename?: 'products', id: any, name: string } | null, property?: { __typename?: 'properties', id: any, name: string } | null } | null }> } | null, aiChatSources: Array<{ __typename?: 'ai_chat_sources', id: any, attachment_name: string, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, property?: { __typename?: 'properties', id: any, name: string } | null, product?: { __typename?: 'products', id: any, name: string } | null, installed_product?: { __typename?: 'installed_products', id: any } | null }> } | null> | null };


export const StartChatStreamDocument = gql`
    mutation startChatStream($message: String!, $user_id: String!, $workspace_id: String!, $organization_id: String!, $stream_id: String!, $doctrine_chat_id: String, $selected_properties_ids: [String], $selected_installed_products_ids: [String], $selected_products_ids: [String], $installed_product_id: String, $shop_product_id: String, $guide_id: String, $files: [FileAttachmentInput!], $is_brief: Boolean, $brief_frequency: String, $chat_type: String, $chat_origin: String, $screen_description: String, $screen_property_id: String, $screen_jurisdiction_id: String) {
  start_chat_stream(
    message: $message
    user_id: $user_id
    workspace_id: $workspace_id
    organization_id: $organization_id
    stream_id: $stream_id
    doctrine_chat_id: $doctrine_chat_id
    selected_properties_ids: $selected_properties_ids
    installed_product_id: $installed_product_id
    shop_product_id: $shop_product_id
    guide_id: $guide_id
    selected_installed_products_ids: $selected_installed_products_ids
    selected_products_ids: $selected_products_ids
    files: $files
    is_brief: $is_brief
    brief_frequency: $brief_frequency
    chat_type: $chat_type
    chat_origin: $chat_origin
    screen_description: $screen_description
  ) {
    id
    message
    isSystem
    createdAt
    userId
    user {
      id
      first_name
      last_name
      email
      profile_photo
    }
    chatId
    multimodal_attachments {
      id
      fileName
      mimeType
      publicUrl
      fileType
      fileKey
      gsUri
    }
    thoughts
    citations {
      chunks {
        uri
        title
      }
      supports {
        segment {
          text
          startIndex
          endIndex
        }
        groundingChunkIndices
      }
    }
    aiChat {
      id
      doctrine_chat_id
      workspace_id
      partition_id
      partitions_ids
      organization_id
      created_at
      doctrine_title
      is_brief
      brief_frequency
      ai_chat_user_selections {
        id
        property_id
        property {
          id
          name
        }
        product_id
        product {
          id
          name
        }
        installed_product_id
        installed_product {
          id
          product_id
          product {
            id
            name
          }
          property_id
          property {
            id
            name
          }
        }
        shop_product_id
        shop_product {
          id
          product_id
          product {
            id
            name
          }
          property_id
          property {
            id
            name
          }
        }
      }
    }
    aiChatSources {
      id
      attachment_name
      photo_link
      document_link
      video_link
      audio_link
      site_link
      property {
        id
        name
      }
      product {
        id
        name
      }
      installed_product {
        id
      }
    }
  }
}
    `;
export type StartChatStreamMutationFn = Apollo.MutationFunction<StartChatStreamMutation, StartChatStreamMutationVariables>;

/**
 * __useStartChatStreamMutation__
 *
 * To run a mutation, you first call `useStartChatStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChatStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChatStreamMutation, { data, loading, error }] = useStartChatStreamMutation({
 *   variables: {
 *      message: // value for 'message'
 *      user_id: // value for 'user_id'
 *      workspace_id: // value for 'workspace_id'
 *      organization_id: // value for 'organization_id'
 *      stream_id: // value for 'stream_id'
 *      doctrine_chat_id: // value for 'doctrine_chat_id'
 *      selected_properties_ids: // value for 'selected_properties_ids'
 *      selected_installed_products_ids: // value for 'selected_installed_products_ids'
 *      selected_products_ids: // value for 'selected_products_ids'
 *      installed_product_id: // value for 'installed_product_id'
 *      shop_product_id: // value for 'shop_product_id'
 *      guide_id: // value for 'guide_id'
 *      files: // value for 'files'
 *      is_brief: // value for 'is_brief'
 *      brief_frequency: // value for 'brief_frequency'
 *      chat_type: // value for 'chat_type'
 *      chat_origin: // value for 'chat_origin'
 *      screen_description: // value for 'screen_description'
 *      screen_property_id: // value for 'screen_property_id'
 *      screen_jurisdiction_id: // value for 'screen_jurisdiction_id'
 *   },
 * });
 */
export function useStartChatStreamMutation(baseOptions?: Apollo.MutationHookOptions<StartChatStreamMutation, StartChatStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartChatStreamMutation, StartChatStreamMutationVariables>(StartChatStreamDocument, options);
      }
export type StartChatStreamMutationHookResult = ReturnType<typeof useStartChatStreamMutation>;
export type StartChatStreamMutationResult = Apollo.MutationResult<StartChatStreamMutation>;
export type StartChatStreamMutationOptions = Apollo.BaseMutationOptions<StartChatStreamMutation, StartChatStreamMutationVariables>;